import type { IStatusProps } from 'shared/ui/Status'
import { type ISurveyNpsGroup } from 'entities/Surveys/api/types'

export const npsGroupIntents: Record<ISurveyNpsGroup, IStatusProps['intent']> = {
  promoter: 'positive',
  passive: 'warning',
  detractor: 'negative',
}
